/**
 * DEPRECATED LOGIN PAGE - DO NOT USE
 *
 * This page has been disabled. All authentication now flows through AIEW (ai-edge.io).
 * Users should never land here. If they do, we show nothing to avoid confusion.
 *
 * Authentication flow:
 * 1. Unauthenticated users are redirected directly to AIEW login from ProtectedRoute
 * 2. After AIEW login, users return to /auth/callback
 * 3. Callback handles token exchange and redirects to app
 *
 * This route exists only to prevent errors if old bookmarks/links point here.
 */
export function Login() {
  // Render nothing - this page should never be shown
  return null
}
